import { render, staticRenderFns } from "./order_xbd.vue?vue&type=template&id=afdca842&scoped=true&"
import script from "./order_xbd.vue?vue&type=script&lang=js&"
export * from "./order_xbd.vue?vue&type=script&lang=js&"
import style0 from "./order_xbd.vue?vue&type=style&index=0&id=afdca842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdca842",
  null
  
)

export default component.exports